import { render } from "./OrderList.vue?vue&type=template&id=77f61a64&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=77f61a64&scoped=true&lang=scss"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f61a64"]])

export default __exports__